//Copyright (C) Siemens Healthineers AG 2024, All rights reserved. Restricted
//
/**
 * Created by z003f2zh on 20.02.2017.
 */

(function () {

    'use strict';

    const defaultOptions = {
        minColumnCount: 5,
        columns: [],
        breadcrumbs: []
    };

    const keyUpEvent = {
        enter: 13, 
        up: 38,
        down: 40
    }

    angular.module('container.widgets')
        .directive('srsngFinder', srsngFinder);

    function srsngFinder() {

        return {
            restrict: 'E',
            templateUrl: 'container/ui/app/widgets/finder/finder.html',
            scope: {
                options: '='
            },            
            link: link
        };

        

        function link(scope, element, attrs) {

            _.defaults(scope.options, angular.copy(defaultOptions));

            let itemIndex = 0;

            let columnContainer = element.children('.columns');
            let columnContainerWidth = 0;
            
            setTimeout(() => {
                pollWidthChanges();
            }, 0);
            addPlaceholderColumns();

            $(window).on('resize.finder', function () {
                pollWidthChanges();
                setTimeout(() => {
                    $(window).trigger("resize.scrollpane");
                }, 0);
            });
            

            scope.clickHomeBreadcrumb = () => {
                scope.selectItem(scope.options.columns[0], scope.options.columns[0].selectedItem)
            };

            scope.clickBreadcrumb = column => {
                scope.selectItem(column, column.selectedItem)
            };

            scope.selectItem = (column, item) => {

                if (column.selectedItem !== item) {

                    column.selectedItem = item;

                    if (item.hasChildren) {

                        setColumnData(column.index + 1, {}, item);

                        scope.options.getColumnData(column.index + 1, item).then(columnData => {
                            setColumnData(column.index + 1, columnData, item);
                            if (scope.options.columns[column.index + 1].filterText !== undefined) {scope.filterChanged(scope.options.columns[column.index + 1])}
                        });
                    } else {
                        setColumnData(column.index + 1, {}, item);
                    }
                }

                if (scope.options.columns[column.index + 1]) delete scope.options.columns[column.index + 1].selectedItem;
                scope.options.columns = scope.options.columns.slice(0, column.index + 2);
                addPlaceholderColumns();
            };

            scope.filterChanged = column => {
                if (scope.options.useFilteringService) {
                    filterUsingService(column);
                } else {
                    filterUsingJs(column);
                }
            };

            function filterUsingService(column) {
                scope.options.getColumnData(column.index, column.parentItem, column.filterText).then(columnData => {
                    setColumnData(column.index, columnData, column.parentItem);                                  
                    if(column.filterText != "") {
                        markSelectedItem(column.index, 0);
                    }
                    else {
                        dismarkSelectedItem(column.index, itemIndex);
                        itemIndex = 0;
                    }
                });
            }

            function filterUsingJs(column) {
                if (column.filterText === undefined || column.filterText == "") {
                    column.items = column.unfilteredItems;
                    if(column.items.length > itemIndex) {
                        dismarkSelectedItem(column.index, itemIndex);
                        itemIndex = 0;
                    }
                } else {
                    column.items = _.filter(column.unfilteredItems, function(item) {
                        return item.label.toLowerCase().indexOf(column.filterText.toLowerCase()) != -1;
                    });
                    if (column.items.length != 0) {
                        markSelectedItem(column.index, 0);
                    }
                }
            }
            
            scope.checkEllipsis = (event, item) => {
                let label = event.currentTarget;
                if (label.offsetWidth < label.scrollWidth) item.showTooltip = true;
                else delete item.showTooltip;
            };

            scope.goToItem = ($event, column)  => {

                if(event.keyCode == keyUpEvent.down || event.keyCode == keyUpEvent.up) {
                    dismarkSelectedItem(column.index, itemIndex);                
                    if(event.keyCode == keyUpEvent.down && itemIndex < (column.items.length - 1)) {
                        itemIndex += 1;     
                    }
                    if(event.keyCode == keyUpEvent.up && itemIndex != 0)  {     
                        itemIndex -= 1;
                    }       
                    markSelectedItem(column.index, itemIndex);
                }
                if(event.keyCode == keyUpEvent.enter) {
                    var selectedItem = column.items[itemIndex];
                    scope.selectItem(column, selectedItem);
                    dismarkSelectedItem(column.index, itemIndex);
                    itemIndex = 0;
                }
            }

            function markSelectedItem (columnIndex, itemIndex)  {               
                document.getElementById(columnIndex + "-" + itemIndex).classList.add("first-item");                    
            }

            function dismarkSelectedItem (columnIndex, itemIndex)  {               
                document.getElementById(columnIndex + "-" + itemIndex).classList.remove("first-item");                    
            }

            function addPlaceholderColumns() {

                for (let i = scope.options.columns.length; i < scope.options.minColumnCount; i++) {
                    setColumnData(i, {}, undefined, true);
                }
                updateColumnWidths();
                setTimeout(() => {
                    $(window).trigger("resize.scrollpane");
                    columnContainer.scrollLeft(columnContainer[0].scrollWidth);
                }, 0);
            }

            function setColumnData(columnIndex, data, parentItem, isPlaceholder) {
                if (columnIndex > scope.options.columns.length - 1) scope.options.columns.push({});
                let column = scope.options.columns[columnIndex];
                column.index = columnIndex;
                column.title = data.title;
                column.items = data.items;
                column.unfilteredItems = data.items;
                column.parentItem = parentItem;
                column.placeholder = isPlaceholder;

                if (column.items) {

                    column.selectedItem = column.items.find(item => _.isEqual(item, column.selectedItem));

                    if (!column.selectedItem) {
                        scope.options.columns = scope.options.columns.slice(0, column.index + 1);
                        addPlaceholderColumns();
                    }
                }
            }

            function updateColumnWidths() {
                
                let baseColumnWidth = columnContainerWidth / scope.options.minColumnCount;
                scope.options.columns.forEach(column => column.baseWidth = baseColumnWidth);
            }

            function pollWidthChanges() {

                let newWidth = columnContainer.width();

                if (newWidth != columnContainerWidth) {

                    columnContainerWidth = newWidth;
                    scope.$evalAsync(updateColumnWidths);
                }
            }

            function resetSelectedItems() {
                scope.options.columns.forEach(column => {
                    column.selectedItem = undefined;
                });
            }

            setColumnData(0, {});
            scope.options.init().then(() => {

                scope.options.getColumnData(0).then(columnData => {
                    setColumnData(0, columnData);
                });
            });
            resetSelectedItems();
        }
    }
})();